<template>
  <div class="home-card-wrapper" v-if="initHasTask || cardList.length">
    <div class="top-content">
      <span class="left">{{ $t('APP_HOME.wo-de-dai-ban') }}</span>
      <span class="right" @click="goTasks"
        >{{
          cardList.length
            ? $t('APP_HOME.cha-kan-total-ge-dai-chu-li', [total])
            : $t('APP_HOME.cha-kan-yi-chu-li-dai-ban')
        }}<i class="iconfont wxm-right"></i
      ></span>
    </div>
    <swipe
      v-if="cardList.length"
      @change="onChange"
      ref="swipe"
      :loop="loop"
      :autoplay="interval"
      height="100%"
      :show-indicators="showDots"
      class="swiper-card-wrapper"
      dots-class="dot"
    >
      <swipe-item
        class="swiper-demo-img"
        v-for="(itemData, index) in cardList"
        @click="goDetail(itemData)"
        :key="index"
      >
        <div class="card-content">
          <div class="title-content">
            <img class="icon" :src="iconImage[itemData.iconType]" />
            <span class="title">{{ itemData.title }}</span>
            <template v-if="itemData.spcTags && itemData.spcTags.length">
              <span class="tag" v-for="(v, i) in itemData.spcTags" :key="i">
                {{ v }}
              </span>
            </template>
          </div>
          <div class="primitive-content">
            <p class="left">{{ itemData.primitiveContent }}</p>
            <p class="right">{{ itemData.contentSlot }}</p>
          </div>
          <div class="summary" v-if="itemData.summary">
            <p class="left" style="white-space: pre-line" v-html="itemData.summary"></p>
          </div>
          <div
            class="btn-content"
            v-if="itemData.messageStatus === 'OPEN' && itemData.actions && itemData.actions.length"
          >
            <span
              class="btn"
              :class="getClass(item)"
              v-for="(item, i) in itemData.actions"
              :key="i"
              @click.stop="goPath(item, index)"
            >
              {{ item.name }}
            </span>
          </div>
          <div
            v-if="itemData.iconType === 'OTAM_PUNCH_IN' || itemData.iconType === 'OTAM_PUNCH_OUT'"
            class="btn-content"
          >
            <span class="btn pay" @click.stop="goDetail(itemData)">{{ $t('APP_HOME.qu-da-ka') }}</span>
          </div>
        </div>
      </swipe-item>
    </swipe>
  </div>
  <popup teleport="body" v-model:show="showEdit" position="bottom" round :style="{ height: '16rem', width: '100%' }">
    <div class="task-content">
      <div class="task-header">
        <p class="task-left"></p>
        <p class="task-title">{{ $t('APP_HOME.shen-pi-yi-jian') }}</p>
        <p class="task-close" @click="onClose">
          <i class="iconfont wxm-close"></i>
        </p>
      </div>
      <field
        class="task-input-wrapper"
        v-model="keyword"
        rows="5"
        autosize
        type="textarea"
        maxlength="100"
        :placeholder="$t('APP_HOME.qing-shu-ru')"
        show-word-limit
      />
      <div class="task-btn-wrapper" @click="onSure">
        {{ $t('APP_HOME.que-ren-bo-hui') }}
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from 'vant/es/popup'
import Field from 'vant/es/field'

import User from '@home/data/User'
import { trace } from 'app-core/lib/trace'
import { buriedPoint } from '../../lib/buriedPoint'
import proccessUrl from '../../lib/proccessUrl'
import Swipe from 'vant/es/swipe'
import SwipeItem from 'vant/es/swipe-item'
import 'vant/es/swipe/style/index'
export default {
  name: 'homeCard',
  props: {
    num: {
      type: [Number, String],
      default: 10
    },
    statusList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Popup,
    Field,
    Swipe,
    SwipeItem
  },
  data() {
    return {
      showLoading: false,
      initHasTask: false,
      keyword: '',
      pageIndex: 1,
      curUrl: null,
      curIndex: null,
      showEdit: false,
      total: 0,
      hasNextPage: false,
      cardList: [],
      iconImage: {
        LIQ_PERSONAL_BILL:
          'https://static.service.z-trip.cn/resources/pic/1235768438074-7cd6038c-3f0f-4418-9c42-a4d8a46ce8da.svg',
        OTAM_TRAVEL_PLAN:
          'https://static.service.z-trip.cn/resources/pic/1254174703331-1e20048d-a02b-4381-84f5-cf238119b3d6.svg',
        PAY_CORP_PAYMENT_FORM:
          'https://static.service.z-trip.cn/resources/pic/1254174559132-0b068ef4-2bb5-47ff-bf34-714c382e0b6f.svg',
        EC_ER_FORM:
          'https://static.service.z-trip.cn/resources/pic/1254174517550-b58af71f-7ea5-4c7d-af59-a42b56d2bfd1.svg',
        FLIGHT_ORDER:
          'https://static.service.z-trip.cn/resources/pic/1254174472832-a14dd840-3469-4e73-9c29-e486e600fdb5.svg',
        INTL_TRIP:
          'https://static.service.z-trip.cn/resources/pic/1254174472832-a14dd840-3469-4e73-9c29-e486e600fdb5.svg',
        HOTEL_ORDER:
          'https://static.service.z-trip.cn/resources/pic/1254174423359-c502bad4-b89a-457e-93c9-13cf60f0544e.svg',
        TRAIN_ORDER:
          'https://static.service.z-trip.cn/resources/pic/1254174386040-a984caad-5cf9-4bee-ab8d-e3938892a02e.svg',
        OTAM_PUNCH_IN:
          'https://static.service.z-trip.cn/resources/pic/1246909093151-d7fcb21a-3c6b-484c-992d-c98c691f9db2.svg',
        OTAM_PUNCH_OUT:
          'https://static.service.z-trip.cn/resources/pic/1246909093151-d7fcb21a-3c6b-484c-992d-c98c691f9db2.svg'
      }
    }
  },
  watch: {
    cardList: {
      handler(val) {
        this.$emit('hasChangeTask', val && val.length)
      },
      deep: true
    }
  },
  mounted() {
    this.getActionList()
  },
  methods: {
    onChange(index) {
      // 最后一条数据时候获取下一页数据
      if (this.hasNextPage && index === this.cardList.length - 1) {
        this.pageIndex++
        this.getActionList()
      }
    },
    async getActionList(loading = false) {
      const res = await User.getActionList({
        statuses: 'OPEN',
        pageSize: 20,
        pageIndex: this.pageIndex
      })
      if (loading) this.showLoading = false
      if (res.code === '0') {
        this.total = res.data.total
        this.initHasTask = res.data.list.length > 0
        this.hasNextPage = res.data.currentPage < res.data.totalPage
        if (res.data.list.length > 0) {
          res.data.list.forEach((item) => {
            if (item.summary && item.summary.includes('/\n/g')) {
              item.summary = item.summary.replace(/\n/g, '<br/>')
            }
          })
        }
        if (this.pageIndex === 1) {
          this.cardList = res.data.list
        } else {
          let cur = JSON.parse(JSON.stringify(this.cardList)) || []
          if (cur.length) {
            this.cardList = this.cardList.concat(res.data.list)
            this.$refs.swipe.swipeTo(cur.length)
          }
        }
        if (this.cardList.length) {
          buriedPoint('Home_Qa_Visibile')
        }
        trace.tag('RENDER_TODO')
        this.$emit('rendered')
      } else {
        console.error(res.msg)
      }
    },

    goPath(item, index) {
      this.curIndex = index

      if (item.type === 'OPEN' && item.actionUrl) {
        window.open(item.actionUrl)
      } else if (item.type === 'GO' || item.name === this.$t('APP_HOME.qu-zhi-fu')) {
        buriedPoint('Home_Qa_Pay')
        if (item.actionUrl && item.actionUrl.indexOf('?') > -1) {
          let orderId = item.actionUrl.split('?')[1].split('=')[1]
          $jump.orderDetail(this, orderId)
        }
      } else {
        if (item.type === 'REJECT') {
          this.curUrl = item.actionUrl
          this.showEdit = true
          buriedPoint('Home_Qa_Reject')
        } else {
          buriedPoint('Home_Qa_Pass')
          this.getActionToDo(item.actionUrl, item.type)
        }
      }
    },

    async getActionToDo(url = '', type = 'REJECT') {
      if (!url) return
      if (type === 'REJECT' && this.keyword) {
        url += url.includes('?') ? `&comments=${this.keyword}` : `?comments=${this.keyword}`
      }

      this.$w.loading.show()
      const res = await User.getActionToDo(url)
      this.$w.loading.hide()
      this.showEdit = false
      if (res.success) {
        this.keyword = ''
        this.total = this.total - 1
        this.cardList.splice(this.curIndex, 1)
        // 如果删除的是最后一项任务，并且没有下一页数据，则隐藏卡片， 如果有下一页数据，则重新请求数据
        if (this.cardList.length === 0) {
          if (this.hasNextPage) {
            this.showLoading = true
            setTimeout(() => {
              this.getActionList(true)
            }, 2000)
          } else {
            this.$w.toast.text(this.$t('APP_HOME.dang-qian-mei-you-dai-ban-de-s'))
          }
        } else {
          this.$w.toast.text(
            type === 'REJECT' ? this.$t('APP_HOME.bo-hui-cheng-gong') : this.$t('APP_HOME.shen-pi-tong-guo')
          )
        }
      } else {
        this.$w.toast.text(res.message || this.$t('APP_HOME.dai-ban-shi-xiang-ren-wu-shi-b'))
      }
    },

    onSure() {
      this.getActionToDo(this.curUrl)
    },

    getClass(item) {
      let classMap = {
        REJECT: 'reject',
        PASS: 'pass',
        GO: 'pay',
        OPEN: 'pay',
        去支付: 'pay'
      }
      return classMap[item.type || item.name]
    },

    goDetail(item) {
      if (!item.taskUrl) return
      if (item.taskUrlOpenType === 'open') {
        window.open(item.taskUrl)
      } else {
        // if (item.iconType === 'OTAM_TRAVEL_PLAN') {
        //   window.$jump.goLocPage('/mg/control/plan/travelapproval')
        // } else {
          proccessUrl(item.taskUrl, this, {
            showLoading: true,
            totalSize: 22
          })
        // }
      }
      buriedPoint('Home_Qa_Detail')
    },

    goTasks() {
      buriedPoint('Home_Qa_Tasks')
      this.$router.push({
        path: '/common/tasks',
        query: {
          index: this.cardList.length ? 0 : 1
        }
      })
    },

    onClose() {
      this.keyword = ''
      this.showEdit = false
    }
  }
}
</script>

<style scoped lang="scss">
.top-content {
  padding-bottom: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: #333;
  background-color: #fff;
  .left {
    font-weight: 500;
  }
  .right {
    display: flex;
    align-items: center;
    font-size: 0.7rem;
    color: #8c8c8c;
  }
}
.icon {
  margin-right: 6px;
  width: 16px;
  height: 16px;
}
.home-card-wrapper {
  margin-top: 0.6rem;
  padding: 0.6rem 0.6rem 0 0.6rem;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0.4rem;
  box-shadow: 0 0.1rem 1rem rgba(120, 154, 187, 0.2);
  .card-content {
    padding-bottom: 1rem;
  }
  .title-content {
    margin-bottom: 0.3rem;
    display: flex;
    align-items: center;

    .title {
      margin-right: 0.4rem;
      font-size: 0.7rem;
      color: #333;
    }
    .tag {
      padding: 0.05rem 0.1rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 0.5rem;
      color: #ff6e51;
      border: 1px solid #ffddd6;
      border-radius: 0.2rem;
    }
  }
  .primitive-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      font-size: 0.8rem;
      color: #333;
      font-weight: 600;
    }
  }
  .summary {
    display: flex;
    align-items: center;
    font-size: 0.7rem;
    color: #999;
  }
  .btn-content {
    margin-top: 0.6rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .btn {
      margin-right: 0.4rem;
      padding: 0.2rem 1rem;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.8rem;
      color: #666;
    }
    .btn:last-child {
      margin-right: 0;
    }
    .btn.reject {
      color: #ff6e51;
      border: 1px solid #ffccc2;
    }
    .btn.pay,
    .btn.pass {
      color: var(--main-color);
      border: 1px solid var(--main-light-color);
    }
  }
}
</style>
<style lang="scss">
.task-header {
  width: 100%;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.7rem;
  color: #333;
  .task-close {
    color: #666;
  }
}
.task-input-wrapper {
  background-color: #eef1f6;
}
.task-content {
  padding: 0 0.6rem;
  background-color: #fff;
}
.task-btn-wrapper {
  margin-top: 1rem;
  height: 2rem;
  background-color: var(--main-color);
  border-radius: 0.4rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
}
</style>
